/*
 * Copyright (c) Nexign, JSC, 2020.
 */
/**
 * Init translation for Labels Import
 *
 * @author Anton Panasenko
 * @version 1.3.1
 * @since 1.3.0
 */

import {
    ELabelsImportField,
    ELabelsImportRowStatus,
    ELabelsImportSteps,
} from '../../../../pages/PageLabelsImport/labelsImportConstants';
import { ILabelsImportTranslation } from '../../types/wizards/labelsImport';

export const initLabelsImportTranslation: ILabelsImportTranslation = {
    chooseFileButton: '',
    chooseFileDropZoneText: '',
    chooseFileHeader: '',
    error: {
        codes: {},
        defaultMessage: '',
    },
    exportErrorsButton: '',
    fileRequirementsMessage: '',
    interruptedValidationMessage: '',
    maxRowsExceededMessage: '',
    status: {
        [ELabelsImportRowStatus.FULLY_IMPORTED]: '',
        [ELabelsImportRowStatus.NOT_IMPORTED]: '',
        [ELabelsImportRowStatus.PARTIALLY_IMPORTED]: '',
    },
    steps: {
        [ELabelsImportSteps.File]: '',
        [ELabelsImportSteps.Final]: '',
    },
    table: {
        [ELabelsImportField.LABEL]: '',
        [ELabelsImportField.MSISDN]: '',
        [ELabelsImportField.STATUS]: '',
    },
    title: '',
    validatedLabelsMessage: '',
    validationStatus: {
        cancelButton: '',
        fileProcess: '',
        rowsErrors: '',
        rowsProcessed: '',
    },
};
